module.exports = __webpack_public_path__ + "static/img/taiheTop.7dc8256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiheTop.jpg
// module id = iH3M
// module chunks = 2